<template>
  <nav class="sidebar-nav" :class="{ toggle: toggler }">
    <div class="sidebar-logo">
      <svgHelper name="logo" />
    </div>
    <ul class="list-group">
      <li>
        <router-link
          :to="{ name: 'user-applications' }"
          class="list-group-item list-group-item-action"
        >
          <i class="far fa-chart-bar mr-2"></i>Applications
        </router-link>
      </li>
      <li style="position: relative;">
        <router-link
          :to="{ name: 'user-search-jobs' }"
          class="list-group-item list-group-item-action"
          :class="
            getGuide.show === true && getGuide.step === 5
              ? 'animate__animated animate__headShake animate__infinite	animate__slow'
              : ''
          "
        >
          <i class="fas fa-filter mr-2"></i>Search Jobs
        </router-link>
        <div
          v-if="getGuide.show === true && getGuide.step === 5"
          class="guide-box animate__animated animate__fadeIn animate__faster jobtab"
        >
          <span>Search Jobs</span>
          <p>
            This is it! Start searching for opportunities here, or let us personally reach out when
            your dream opportunity arises.
          </p>
          <div class="buttons">
            <button @click="closeGuide" class="btn btn-primary">Get started!</button>
          </div>
        </div>
      </li>
      <li style="position: relative;">
        <router-link
          :class="
            getGuide.show === true && getGuide.step === 4
              ? 'animate__animated animate__headShake animate__infinite	animate__slow'
              : ''
          "
          :to="{ name: 'freelancing-network' }"
          class="list-group-item list-group-item-action"
        >
          <i class="fas fa-dove mr-2"></i>Freelancing
        </router-link>
        <div
          v-if="getGuide.show === true && getGuide.step === 4"
          class="guide-box animate__animated animate__fadeIn animate__faster freelance"
        >
          <span>Freelancing</span>
          <p>
            Consider joining our Freelancing Network! Our opportunities are often fully remote and
            long-term.
          </p>
          <div class="buttons">
            <button @click="closeGuide" class="btn btn-danger">Close</button>
            <button @click="nextStep" class="btn btn-primary">Next</button>
          </div>
        </div>
      </li>
      <li style="position: relative;">
        <router-link
          :class="
            getGuide.show === true && getGuide.step === 1
              ? 'animate__animated animate__headShake animate__infinite	animate__slow'
              : ''
          "
          :to="{ name: 'user-profile' }"
          class="list-group-item list-group-item-action"
        >
          <i class="fas fa-user-alt mr-2"></i>My Profile
        </router-link>

        <div
          v-if="getGuide.show === true && getGuide.step === 1"
          class="guide-box animate__animated animate__fadeIn animate__faster profile"
        >
          <span>My Profile</span>
          <p>
            Fill out this section with your details to start applying for jobs and to receive
            personalized opportunities directly from us.
          </p>
          <div class="buttons">
            <button @click="closeGuide" class="btn btn-danger">Close</button>
            <button @click="nextStep" class="btn btn-primary">Next</button>
          </div>
        </div>
      </li>
      <!--       <li>
        <router-link :to="{ name: 'sharkman' }" class="list-group-item list-group-item-action">
          <i class="fas fa-user-alt mr-2"></i>My Profile
        </router-link>
      </li> -->
      <!--  <li>
        <router-link to="/user/documents" class="list-group-item list-group-item-action">
          <i class="fas fa-file-invoice mr-2"></i> Documents
        </router-link>
      </li>
      <li>
        <router-link to="/user/subscriptions" class="list-group-item list-group-item-action">
          <i class="fas fa-rss mr-2"></i> Subscriptions
        </router-link>
      </li> -->
      <li class="separator"></li>
      <li>
        <router-link :to="{ name: getSettings }" class="list-group-item list-group-item-action">
          <i class="fas fa-user-cog mr-2"></i> Settings
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'logout' }" class="list-group-item list-group-item-action">
          <i class="fas fa-sign-out-alt mr-2"></i> Sign Out
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
//import { userRoleMixin } from '../../mixins/userRoleMixin';

export default {
  props: ['toggler'],
  methods: {
    ...mapActions(['setCandidateGuideStep']),
    nextStep() {
      this.setCandidateGuideStep(this.getGuide.step + 1);
    },
    closeGuide() {
      this.$store.commit('SET_GUIDE_SHOW', false);
      this.hideGuide();
    },

    hideGuide() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/candidate/updatetutorial`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.intro = false;
        });
    },
  },
  computed: {
    ...mapGetters(['getAccType', 'getGuide']),
    getSettings() {
      switch (this.getAccType) {
        case 'manager':
          return 'manager-settings';
        case 'admin':
          return 'admin-settings';
        case 'candidate':
          return 'candidate-user-settings';
        case 'recruiter':
          return 'recruiter-settings';
        default:
          return '';
      }
    },
  },
  mounted() {
    console.log(this.getGuide);
  },
};
</script>

<style lang="scss" scoped>
.guide-box {
  background-color: #eeeded;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  width: 320px;
  z-index: 9999;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
  span {
    font-size: 18px;
    display: block;
    font-weight: 600;
    margin-bottom: 15px;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  p {
    font-size: 14px;
  }
  .buttons {
    display: flex;
    gap: 15px;
    .btn {
      flex: 1;
      font-size: 13px;
    }
  }
  &.profile {
    left: 112%;
    top: -85px;
    &:before {
      content: '';
      position: absolute;
      top: 50%; /* center vertically */
      left: -18px; /* place to the left of the element */
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 17px solid #eeeded; /* same as .linked background color */
    }
  }
  &.freelance {
    left: 112%;
    top: -70px;
    &:before {
      content: '';
      position: absolute;
      top: 50%; /* center vertically */
      left: -18px; /* place to the left of the element */
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 17px solid #eeeded; /* same as .linked background color */
    }
  }
  &.jobtab {
    left: 112%;
    top: -85px;
    &:before {
      content: '';
      position: absolute;
      top: 50%; /* center vertically */
      left: -18px; /* place to the left of the element */
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 17px solid #eeeded; /* same as .linked background color */
    }
  }
}
.sidebar-logo {
  text-align: center;
  padding: 2rem;

  .svg-icon {
    width: 80px;
    height: 75px;
    margin-left: 10px;
  }
}

.list-group {
  li {
    &:nth-last-of-type(-n + 2) {
      display: none;
    }
  }
  .separator {
    margin: 15px 0;
    height: 1px;
    border-bottom: 1px dashed #ddd;
    opacity: 0.2;
    display: none;
  }
}

@media only screen and (max-width: 1251px) {
  .guide-box {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .list-group {
    li {
      &:nth-last-of-type(-n + 2) {
        display: block;
      }
    }

    .separator {
      display: block;
    }
  }
}
</style>
